document.addEventListener("DOMContentLoaded", () => {
  console.log("DOMContentLoaded");
  // 処理内容

  // DOM取得
  const menuButton = document.getElementsByClassName("js-menuButton")[0];
  const drawerMenu = document.getElementsByClassName("js-drawer")[0];
  const drawerOverlay = document.getElementsByClassName("js-overlay")[0];

  const categorySliderSections = document.querySelectorAll(".top-category");
  const comingSoonSliderSection = document.querySelector(".top-coming-soon");
  const pickupSliderSection = document.querySelector(".p-pickup-collection");
  const bannerSliderSection = document.querySelector(".p-banner");

  const footerAccordionToggles = document.querySelectorAll(".js-accordion-toggle");

  if (menuButton && drawerMenu && drawerOverlay) {
    handleClickMenuButton(menuButton, drawerMenu, drawerOverlay);
    handleClickDrawerOverlay(menuButton, drawerMenu, drawerOverlay);
  }

  CollectionsTabChange();
  accordionToggle(footerAccordionToggles);

  categorySliderSections.forEach((sec) => categorySliderInit(sec));
  comingSoonSliderInit(comingSoonSliderSection);
  bannerSliderInit(bannerSliderSection);
  pickupSliderInit(pickupSliderSection);
});

// スクロール値保持用のオブジェクト
const scrollData = {
  scrollTop: 0,
};

/**
 * 100vh Safari対策
 */
// 1vhをブラウザにあわせて再計算
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

let vw = window.innerWidth;

// 画面のサイズ変動があったら高さを再計算
window.addEventListener("resize", () => {
  if (vw === window.innerWidth) {
    return;
  }

  vw = window.innerWidth;
  setFillHeight(); //1vh計算
});
//初期化
setFillHeight();

// 374px以下はviewport固定
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value = window.outerWidth > 374 ? "width=device-width,initial-scale=1" : "width=374";
    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }
  addEventListener("resize", switchViewport, false);
  switchViewport();
})();

// ハンバーガーボタンをスクロールで固定
const hamburgerScroll = (menuButton) => {
  if (!menuButton) {
    return false;
  }
  const hamburgerButtonOffsetTop = menuButton.offsetTop - 12;
  const topMvHeight = document.querySelector(".custom-mainVisual")?.offsetHeight;

  window.addEventListener("scroll", () => {
    if (window.pageYOffset > hamburgerButtonOffsetTop) {
      menuButton.classList.add("is-fixed");
      if (window.pageYOffset > topMvHeight) {
        menuButton.classList.add("is-dark");
      } else {
        menuButton.classList.remove("is-dark");
      }
    } else {
      menuButton.classList.remove("is-fixed");
    }
  });
};

// クリック処理
const handleClickMenuButton = (menuButton, drawerMenu, drawerOverlay) => {
  menuButton.addEventListener("click", () => {
    // スクロールバーの幅をcss変数に更新
    let scrollbarWidth = window.innerWidth - document.body.clientWidth;
    menuButton.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);

    changeAria(menuButton, drawerMenu, scrollData);
    toggleMenu(menuButton, drawerMenu, drawerOverlay);
  });
};

//横からスライド用 overlayクリックでメニューを閉じる
const handleClickDrawerOverlay = (menuButton, drawerMenu, drawerOverlay) => {
  drawerOverlay.addEventListener("click", () => {
    changeAria(menuButton, drawerMenu, scrollData);
    toggleMenu(menuButton, drawerMenu, drawerOverlay);
  });
};

// WAI-ARIAの値を切り替え
const changeAria = (menuButton, drawerMenu, scrollData) => {
  if (menuButton.getAttribute("aria-expanded") == "false") {
    menuButton.setAttribute("aria-expanded", "true");
    menuButton.setAttribute("aria-label", "メニューを閉じる");
    drawerMenu.setAttribute("aria-hidden", "false");

    // スクロールした値を取得し、topに設定し位置を保存
    scrollData.scrollTop = window.scrollY;
    document.body.style.top = scrollData.scrollTop * -1 + "px";
    // ドロワー展開中はスクロールさせない
    document.body.classList.add("is-noScroll");
  } else {
    menuButton.setAttribute("aria-expanded", "false");
    menuButton.setAttribute("aria-label", "メニューを開く");
    drawerMenu.setAttribute("aria-hidden", "true");

    // topを削除
    document.body.style.top = "";
    document.body.classList.remove("is-noScroll");
    // 保存したスクロール位置を反映
    window.scrollTo(0, scrollData.scrollTop);
  }
};

// ボタンとメニューにclass付与
const toggleMenu = (menuButton, drawerMenu, drawerOverlay) => {
  menuButton.classList.toggle("is-open");
  drawerMenu.classList.toggle("is-open");
  drawerOverlay.classList.toggle("is-open");
};

// コレクションのタブ切り替え
const CollectionsTabChange = () => {
  const collections = document.querySelectorAll(".sorting-collections");

  collections.forEach((collection) => {
    const collectionTabMenu = collection.querySelectorAll(".js-tab-menu");
    const collectionTabHead = collection.querySelectorAll(".js-tab-head");

    collectionTabMenu[0]?.classList.add("is-active");
    collectionTabHead[0]?.classList.add("is-active");

    if (collectionTabHead[0] && collectionTabMenu[0]) {
      for (let i = 0; i < collectionTabMenu.length; i++) {
        const item = collectionTabMenu[i];

        item.addEventListener("click", () => {
          collectionTabMenu.forEach((childItem) => {
            childItem.classList.remove("is-active");
          });
          setTimeout(() => {
            collectionTabHead.forEach((childItem) => {
              childItem.classList.remove("is-active");
            });
          }, 400);

          setTimeout(() => {
            item.classList.add("is-active");
            collectionTabHead[i].classList.add("is-active");
          }, 800);
        });
      }
    }
  });
};

//アコーディオン
const accordionToggle = (buttons) => {
  const accordionButtons = buttons;

  if (!accordionButtons) {
    return false;
  }

  accordionButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const accordionContent = button.nextElementSibling;
      const accordionContentText = accordionContent.firstElementChild;

      if (!accordionContent || !accordionContentText) {
        return false;
      }

      if (accordionContentText.style.maxHeight) {
        accordionContentText.style.maxHeight = null;
        accordionContent.style.maxHeight = null;
      } else {
        const textPaddingHeight =
          accordionContentText.scrollHeight +
          parseInt(window.getComputedStyle(accordionContentText).paddingTop) +
          parseInt(window.getComputedStyle(accordionContentText).paddingBottom);
        accordionContentText.style.maxHeight = textPaddingHeight + "px";
        accordionContent.style.maxHeight = textPaddingHeight + "px";
      }
      button.classList.toggle("is-open");
    });
  });
};

// カテゴリーのスライダー
const categorySliderInit = (section) => {
  if (!section) return;

  const swiperEl = section.querySelector('.top-category .swiper');
  if (!swiperEl || swiperEl.swiper) return;

  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded');
    return;
  }

  const sliderWrap = section.querySelector('.top-category__slider');
  const prevEl = sliderWrap?.querySelector('.js-cat-prev') || null;
  const nextEl = sliderWrap?.querySelector('.js-cat-next') || null;

  const opts = {
    slidesPerView: 'auto',
    spaceBetween: 6,
    freeMode: true,
    watchOverflow: true,
    grabCursor: true,
    touchStartPreventDefault: false,
    observer: true,
    observeParents: true,
    // 両方揃っている時だけナビを有効化
    ...(prevEl && nextEl ? { navigation: { prevEl, nextEl } } : {}),
  };

  const swiper = new Swiper(swiperEl, opts);

  // スライドがロックされたら矢印を無効化（任意）
  const updateLock = () => {
    const locked = swiper.isLocked;
    sliderWrap?.classList.toggle('is-locked', locked);
    if (prevEl) prevEl.disabled = locked;
    if (nextEl) nextEl.disabled = locked;
  };
  updateLock();
  swiper.on('lock', updateLock);
  swiper.on('unlock', updateLock);
  swiper.on('resize', updateLock);
  swiper.on('update', updateLock);

  return swiper;
};


// Coming Soonのスライダー
const comingSoonSliderInit = (comingSoonSliderSection) => {
  if (!comingSoonSliderSection) {
    return false;
  }
  const comingSoonSlider = new Swiper(".top-coming-soon .swiper", {
    slidesPerView: 3.5,
    spaceBetween: 10,
    grabCursor: true,
  });
};

// バナーのスライダー
const bannerSliderInit = (bannerSliderSection) => {
  if (!bannerSliderSection) {
    return false;
  }
  const bannerSlider = new Swiper(".p-banner .swiper", {
    slidesPerView: "auto",
    spaceBetween: 12,
    grabCursor: true,
  });
};

// コレクション > 注目アイテムのスライダー
const pickupSliderInit = (pickupSliderSection) => {
  if (!pickupSliderSection) {
    return false;
  }
  const pickupSlider = new Swiper(".p-pickup-collection .swiper", {
    slidesPerView: "auto",
    spaceBetween: 10,
    grabCursor: true,
  });
};

// スムーススクロール
const smoothScroll = (target, duration = 400, offset = 60) => {
  const targetElement = document.querySelector(target);
  if (!targetElement) return;

  const startPosition = window.pageYOffset;
  const targetPosition = targetElement.getBoundingClientRect().top - offset;
  let startTime = null;

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;
    const elapsedTime = currentTime - startTime;
    const ease = easeInOutQuad(elapsedTime, startPosition, targetPosition, duration);
    window.scrollTo(0, Math.floor(ease));
    if (elapsedTime < duration) requestAnimationFrame(animation);
    else cancelAnimationFrame(animation);
  };

  const easeInOutQuad = (time, start, change, duration) => {
    time /= duration / 2;
    if (time < 1) return (change / 2) * time * time + start;
    time--;
    return (-change / 2) * (time * (time - 2) - 1) + start;
  };

  requestAnimationFrame(animation);
};

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", (e) => {
    e.preventDefault();
    const target = anchor.getAttribute("href");
    smoothScroll(target);
  });
});
